<template>
    <span class="tag is-white" v-if="competitor.paymentDocument">
        <span class="icon">
            <i class="fa fa-check" />
        </span>
    </span>
    <span class="tag is-danger" v-else-if="competitor.containsUnassignedDocuments">
        <span class="icon">
            <i class="fa fa-check" />
        </span>
    </span>
    <span class="tag is-dark" v-else>
        <span class="icon">
            <i class="fa fa-times" />
        </span>
    </span>
</template>

<script setup lang="ts">
    import { CompetitorPaymentWithMetadata } from "../Api/payments";

    defineProps<{
        competitor: CompetitorPaymentWithMetadata;
    }>();
</script>
